import { getFullZodiac } from "@/shared/utils/utils";
import { clsx } from "clsx";
import { Icon } from "@/shared/ui/Icon";

import Aquarius from "@/shared/assets/zodiac/aquarius.svg";
import Aries from "@/shared/assets/zodiac/aries.svg";
import Cancer from "@/shared/assets/zodiac/cancer.svg";
import Capricorn from "@/shared/assets/zodiac/capricorn.svg";
import Gemini from "@/shared/assets/zodiac/gemini.svg";
import Leo from "@/shared/assets/zodiac/leo.svg";
import Libra from "@/shared/assets/zodiac/libra.svg";
import Pisces from "@/shared/assets/zodiac/pisces.svg";
import Sagittarius from "@/shared/assets/zodiac/sagittarius.svg";
import Scorpio from "@/shared/assets/zodiac/scorpio.svg";
import Taurus from "@/shared/assets/zodiac/taurus.svg";
import Virgo from "@/shared/assets/zodiac/virgo.svg";

import cls from "./Zodiac.module.scss";

interface ZodiacProps {
  className?: string;
  zodiac: string;
}

export const Zodiac = ({ zodiac, className }: ZodiacProps) => {
  let imgSrc;

  switch (zodiac) {
    case "ARI":
      imgSrc = Aries;
      break;
    case "TAE":
      imgSrc = Taurus;
      break;
    case "GEM":
      imgSrc = Gemini;
      break;
    case "CAN":
      imgSrc = Cancer;
      break;
    case "LEO":
      imgSrc = Leo;
      break;
    case "VIR":
      imgSrc = Virgo;
      break;
    case "LIB":
      imgSrc = Libra;
      break;
    case "SCO":
      imgSrc = Scorpio;
      break;
    case "SAG":
      imgSrc = Sagittarius;
      break;
    case "CAP":
      imgSrc = Capricorn;
      break;
    case "AQU":
      imgSrc = Aquarius;
      break;
    case "PIS":
      imgSrc = Pisces;
      break;
    default:
      break;
  }

  return (
    <div className={clsx(cls.Zodiac, {}, [className])}>
      <Icon Svg={imgSrc} />
      <div className={cls.Label}>{getFullZodiac(zodiac)}</div>
    </div>
  );
};
